export default "__VITE_ASSET__CSG8zOYW__"